import { breakpoints, Container } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    background-color: white;
    margin: 50px 0;

    ${breakpoints.large} {
        margin: 75px 0;
    }
`;

export const Inner = styled.div`
    ${breakpoints.large} {
        display: flex;
    }
`;

export const Sidebar = styled.aside`
    border-bottom: 1px solid ${transparentize(0.75, colors.brandDark)};
    margin-bottom: 24px;

    ${breakpoints.large} {
        width: 30%;
        padding-right: 60px;
        margin-bottom: 0;
        border-bottom: 0;
    }
`;

export const Main = styled.main`
    ${breakpoints.large} {
        width: 70%;
    }
`;

export const CustomContainer = styled(Container)``;
